import type { BasicBooking_loadingPreference } from '../../../../common/graphql/fragments/gql/BasicBooking';
import { type ApprovalConfig, getApprovalInfo } from '../../../../common/utils/approvalInfo';
import type { BookingFields } from '../../../../common/utils/bookingFields';
import { type GoodsApproval, GoodsApprovalType } from '../../../../common/utils/GoodsApproval';
import { resolveHazardousGoodsApproved } from '../../../../common/utils/hazardousGoodsUtil';
import { resolveLoadingPreferenceApproved } from '../../../../common/utils/loadingPreferenceUtil';
import { shouldShowHazardousGoodsApproval } from '../../../../common/utils/shouldShowHazardousGoodsApproval';
import type { BookingStatus, ColumnId } from '../../../../gql/graphql';

export interface BookingDetailsLocationState {
  addEmptyGoodsItem?: boolean;
  scrollGoodsIntoView?: boolean;
}

function intersection<T>(setA: Set<T>, setB: Set<T>): Set<T> {
  const _intersection = new Set<T>();
  for (const elem of setB) {
    if (setA.has(elem)) {
      _intersection.add(elem);
    }
  }
  return _intersection;
}

export const getFieldsToEdit = (
  shownFields: BookingFields,
  editableFields: ColumnId[],
): BookingFields => {
  if (editableFields.length === 0) {
    return shownFields;
  } else {
    return intersection(shownFields, new Set(editableFields));
  }
};

export const getLoadingPreferenceApprovalInfo = (
  loadingPreference: BasicBooking_loadingPreference | null,
  loadingPreferenceStatusCode: string,
): ApprovalConfig | null => {
  const loadingPreferenceApproval: GoodsApproval = {
    status: resolveLoadingPreferenceApproved(loadingPreference, loadingPreferenceStatusCode),
    type: GoodsApprovalType.LoadingPreference,
  };

  return getApprovalInfo(loadingPreferenceApproval, undefined, true);
};

export const getHazardousGoodsApprovalInfo = (
  hazardousGoods: boolean,
  hazardousGoodsApproved: boolean,
  bookingStatus: BookingStatus | null,
): ApprovalConfig | null => {
  if (!shouldShowHazardousGoodsApproval(bookingStatus, hazardousGoodsApproved)) {
    return null;
  }

  const hazardousGoodsApproval: GoodsApproval = {
    status: resolveHazardousGoodsApproved(false, hazardousGoods, hazardousGoodsApproved),
    type: GoodsApprovalType.Hazardous,
  };
  return getApprovalInfo(hazardousGoodsApproval, bookingStatus, true);
};
